
// Gestionnaire d'erreur pour les notifications ResizeObserver
export const handleResizeObserverError = () => {
  window.addEventListener('error', (e) => {
    if (e.message === 'ResizeObserver loop completed with undelivered notifications.') {
      e.stopImmediatePropagation();
    }
  });
};
